import { Scaling } from "./Scaling";
import { Communication } from "neo-games/Engine/index";
import { Symbol } from "../GameComponents/Symbol";
import { GameManager } from "../Managers/GameManager";
import { BaseView } from "../GameComponents/Base/BaseView";
import { WinAnimatorExtended } from "../CustomComponents/WinAnimatorExtended";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { AppContext } from "../../Common/AppContext";
import { BetManager } from "../Managers/BetManager";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { Logger, NumberUtils } from "neo-common";
import { Languages } from "./Languages";

/**
 * @class CustomUtils
 * @author Marek Turkovic
 * 25.10.2019
 * todo Implement not only on baseResponse, but freespinsRespons etc..
 */

export class CustomUtils {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************
    public static readonly SymbolCherry: number = 1;
    public static readonly SymbolLemon: number = 2;
    public static readonly SymbolOrange: number = 3;
    public static readonly SymbolPlum: number = 4;
    public static readonly SymbolGrape: number = 5;
    public static readonly SymbolWatermelon: number = 6;
    public static readonly SymbolWild: number = 7;
    public static readonly SymbolBonus: number = 8;

    public static getBlendMode(blendMode: number): number {
        if (Scaling.IsIOs) {
            if (blendMode == 1) {
                blendMode = 3;
            }
        }

        return blendMode;
    }

    /**
     *
     * @param src
     * @param childName
     * @param dest
     */

    static swapChilds(src: BaseElement, childName: string, dest: any): void {
        if (src != null && dest.childs[childName] != null) {
            dest.addChildAt(src, dest.getChildIndex(dest.childs[childName]));
        }
    }

    public static updateSpineData(spineData: JSON): JSON {
        if (Scaling.IsIOs) {
            if (spineData != null) {
                let spineTextData = JSON.stringify(spineData);
                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
                spineData = JSON.parse(spineTextData);
            }
        }

        return spineData;
    }

    /**
     * In case of "useCoins" returns number, otherwise return string.
     * @param value
     */
    public static formatWinNumber(value: number): number | string {
        let formatedValue: number | string;
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            formatedValue = parseInt(NumberUtils.devide(value, BetManager.CoinSize).toString());
        } else {
            ImageTextCounterElement.Round = false;
            formatedValue = Languages.formatText(Languages.FormatMoney, value.toString());
        }

        return formatedValue;
    }

    public static getObjectFrom(objName: string, source: any, tp?: any): any {
        if (source != null) {
            if (source[objName] != null) {
                if (tp != null) {
                    if (source[objName] instanceof tp) {
                        return source[objName];
                    } else {
                        if (DEBUG) {
                            CustomUtils.log("ERROR: " + objName + " has bad instance type");
                        }
                    }
                } else {
                    if (source[objName]) {
                        return source[objName];
                    }
                }
            } else {
                if (DEBUG) {
                    CustomUtils.log("ERROR: no " + objName);
                }
            }
        }

        return null;
    }

    public static log(s: string): void {
        if (DEBUG) {
            let compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/CustomUtils.ts
 **/